const General = () => {
  return (
    <div>
      <h1>General</h1>
      {/* General content goes here */}
    </div>
  );
};

export default General;
